// extracted by mini-css-extract-plugin
export default {"footer-legal-links":"footer-legal-links--WR4-j","footerLegalLinks":"footer-legal-links--WR4-j","link":"link--vaVWn"};